export const ServiceStatus = ['待企业确认用户服务', '待用户确认服务', '服务进行中', '待支付服务成果', '待平台审核服务成果', '审核失败，待重新确认', '服务成果待用户确认', '用户异议，待重新确认', '待用户申请结算', '待确认服务结算', '打款中', '打款失败，请联系客服', '重新发起打款', '已完成', '已关闭', '用户拒绝,已关闭']
